module.exports = __webpack_public_path__ + "img/photo-36.5ed62aa4.webp";